import InitApi from "api/InitApi";
import { buildFormData } from "api/BookResource/bookFileUpload";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";

const useEditBook = (book, onClose) => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const update = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");
		const body = deleteEmptyObjects(obj);

		delete body.book_cover;
		delete body.book_file;

		const response = await instance.post(
			`/books/${book}?_method=PATCH`,
			buildFormData(body)
		);

		await Promise.all([
			queryClient.invalidateQueries("books"),
			queryClient.invalidateQueries("myUploadedBooks"),
			queryClient.invalidateQueries("tags"),
		]);

		return response;
	};

	return useMutation(update, {
		onSuccess: async () => {
			onClose?.();
			toast.success("Book updated successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{ className: "max-w-max" }
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useEditBook;
